// extracted by mini-css-extract-plugin
module.exports = {"nav":"mobile-nav-module--nav--5w8z2","link":"mobile-nav-module--link--2W2w-","active":"mobile-nav-module--active--1m_qu"};